function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 0a7 7 0 110 14A7 7 0 017 0zm-.444 3.152L3.184 6.48a.459.459 0 000 .735.723.723 0 00.887 0L6.333 4.78v5.702c0 .286.32.519.667.519.346 0 .667-.233.667-.52V4.77l2.262 2.446a.723.723 0 00.887 0 .459.459 0 000-.736L7.444 3.152a.723.723 0 00-.888 0z"
});

var SvgChangeArrow = function SvgChangeArrow(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgChangeArrow;